import { render, staticRenderFns } from "./StowageBoxes.vue?vue&type=template&id=2a6e444d&"
import script from "./StowageBoxes.vue?vue&type=script&lang=js&"
export * from "./StowageBoxes.vue?vue&type=script&lang=js&"
import style0 from "./StowageBoxes.vue?vue&type=style&index=0&id=2a6e444d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports